module.exports = __webpack_public_path__ + "static/media/carte-bancaire.fd5a369a.svg";